/**
 * Microsoft Clarity — grabacion de sesiones y heatmaps.
 *
 * Un solo proyecto para todos los fronts, igual que el GA compartido. El id es
 * publico (viaja en el bundle del cliente), asi que vive como constante y no
 * como variable de entorno.
 *
 * El gate de produccion esta adentro del snippet, no en los call sites: es el
 * unico lugar que decide si Clarity corre. Se chequea el dominio y no
 * `import.meta.env.PROD` porque los preview deploys de Vercel tambien son
 * builds de produccion y ensuciarian las grabaciones.
 */

export const CLARITY_PROJECT_ID = 'xv41fa3a2s';

const PROD_DOMAIN = 'yugiohargentina.com';

/**
 * Snippet oficial de Clarity envuelto en el gate de dominio. Se devuelve como
 * string para que los dos consumidores (el `<script>` del `<head>` en las apps
 * de TanStack Start y la inyeccion imperativa en las SPA) compartan el mismo
 * codigo.
 */
export const clarityScriptSource = (
  projectId: string = CLARITY_PROJECT_ID
): string => `
(function(){
  var h = window.location.hostname;
  if (h !== '${PROD_DOMAIN}' && !h.endsWith('.${PROD_DOMAIN}')) return;
  (function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", "${projectId}");
})();
`;

/**
 * Inyecta Clarity en el `<head>`. Para las apps que sirven un `index.html`
 * estatico (folder, streaming) y por lo tanto no pueden condicionar el script
 * desde el markup. Idempotente.
 */
export const initClarity = (projectId: string = CLARITY_PROJECT_ID): void => {
  if (typeof document === 'undefined') return;
  if (document.querySelector('script[data-clarity]')) return;

  const script = document.createElement('script');
  script.dataset.clarity = '';
  script.textContent = clarityScriptSource(projectId);
  document.head.appendChild(script);
};
